module.exports = __webpack_public_path__ + "img/D202101_1.7795073c.jpg";